import React from 'react';
import { Flex, Box, Image, Text, Button } from 'rebass/styled-components';
import { StaticQuery, graphql } from 'gatsby';

import doctor from '../../assets/images/doctor.svg';
import bubbleHero from '../../assets/images/bubble-hero.svg';

const Hero = ({ onClick }) => (
  <StaticQuery
    query={graphql`
      query HeroQuery {
        contentfulStudyAboveTheFold {
          tagline
          textblock {
            textblock
          }
          subheader {
            subheader
          }
          image {
            file {
              url
            }
            fluid(toFormat: JPG, quality: 95) {
              src
            }
          }
        }
      }
    `}
    render={data => {
      const {
        image,
        tagline,
        subheader,
        textblock
      } = data.contentfulStudyAboveTheFold;

      return (
        <Flex flexDirection="column" mx={[4, 5]} py={5}>
          <Box maxWidth="415px" mb={3} mx={'auto'}>
            <Image src={`https:${image.fluid.src}`} />
          </Box>
          <Flex flexDirection="column">
            <Box>
              <Text fontSize={2} fontWeight="700" my={2}>
                {tagline}
              </Text>
              <Text fontSize={1} fontWeight="700" fontFamily="lato" my={2}>
                {subheader.subheader}
              </Text>
              <Text fontSize={'14px'} fontFamily="lato" my={2}>
                {textblock.textblock}
              </Text>
              <Button
                variant="main"
                my={3}
                sx={{
                  position: 'relative',
                  zIndex: 10
                }}
                onClick={onClick}
              >
                JOIN THE STUDY
              </Button>
            </Box>
          </Flex>
          <Flex justifyContent="flex-end" flexWrap="wrap" width="100%">
            <Box mt={['-100px', '-80px']} mr={[-4, -5]}>
              <Image src={bubbleHero} />
            </Box>
            <Box mt={['-240px', '-340px']} mr={[-4, 0]}>
              <Image
                src={doctor}
                width="432px"
                sx={{
                  borderRadius: '35%'
                }}
              />
            </Box>
          </Flex>
        </Flex>
      );
    }}
  />
);

export default Hero;
